export async function validarFormatacaoDocumento(documento, tipo) {
  if (tipo === "CPF") {
    // Validar CPF
    return await validarFormatacaoCPF(documento);
  } else if (tipo === "CNPJ") {
    // Validar CNPJ
    return await validarFormatacaoCNPJ(documento);
  } else if (tipo === "RNE") {
    // Validar RNE
    return await validarFormatacaoRNE(documento);
  } else {
    // Tipo de documento inválido
    return false;
  }
}

async function validarFormatacaoCPF(cpf) {
  const cpfFormated = cpf;
  const cpfNoFormated = cpf.replace(/[^\d]+/g, "");

  if (cpfNoFormated === "" || cpfNoFormated.length !== 11) return false;

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpfNoFormated)) return false;

  // Validação do primeiro dígito verificador
  let add = 0;
  for (let i = 0; i < 9; i++)
    add += parseInt(cpfNoFormated.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpfNoFormated.charAt(9))) return false;

  // Validação do segundo dígito verificador
  add = 0;
  for (let i = 0; i < 10; i++)
    add += parseInt(cpfNoFormated.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cpfNoFormated.charAt(10))) return false;

  return true;
}

async function validarFormatacaoCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj === "" || cnpj.length !== 14) return false;

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  // Validação do primeiro dígito verificador
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  // Validação do segundo dígito verificador
  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
}

async function validarFormatacaoRNE(rne) {
  // Verifica se o RNE tem o comprimento mínimo esperado
  if (rne.length < 8) {
    return false;
  }

  // Verifica se o RNE contém apenas números e letras
  if (!/^[0-9A-Za-z]+$/.test(rne)) {
    return false;
  }

  // Se passou por todas as verificações, retorna true
  return true;
}
